$(document).ready(function()
{
    
    function popupSmallCartPrompt()
    {
        var currentCartItems = localStorage.getItem('currentCartItems');
        var currentCount = 0;
        if (currentCartItems)
        {
            currentCartItems =  JSON.parse(currentCartItems);
        }
        else
        {
            currentCartItems = {};
        }

        for (var key in currentCartItems) 
        {
            if (currentCartItems.hasOwnProperty(key)) 
            {
                currentCount += currentCartItems[key]['qty'];
            }
        }

        updateSmallCartPrompt();

        function updateSmallCartPrompt()
        {
            if (currentCount > 0)
            {
                var show_count = currentCount;

                show_count += ( currentCount == 1 ) ? " item" : " items";

                $('#generalCartLink').removeClass("hide");
                $('#generalCartLink span.cart-info').html(show_count);
            }
            else
            {
                $('#generalCartLink').addClass("hide");
                $('#generalCartLink span.cart-info').html();
            }
        }



    };

    if ( $('#generalCartLink').length )
    {
        popupSmallCartPrompt();
    }



});